var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"project-index primary"},[_c('InstallationWizardInfoPopup'),(_vm.isProjectReady)?_c('router-view'):_vm._e(),(_vm.projectLoader)?_c('div',{staticClass:"project-index__loader"},[_c('CircleSpinner',{attrs:{"size":80,"color":"accent"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }